import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { defer } from 'rxjs/observable/defer';
import { Effect, Actions } from '@ngrx/effects';
import { switchMap, catchError, map } from 'rxjs/operators';
import { ClientData } from '../../providers/client';
import { ENV } from '@app/env';
import * as clientActions from '../actions/client.actions';
import * as authActions from '../actions/auth.actions';

@Injectable()
export class ClientEffects {

  /**
   * Este efecto carga la informacion general del cliente
   */
  @Effect()
  getClient$ = this.actions
    .ofType(clientActions.GET_CLIENT)
    .pipe(
      switchMap(() => this.clientProvider._searchClient(ENV.client)),
      map((client: any) => new clientActions.GetClientSuccess(client)),
      catchError(err => Observable.of(new clientActions.GetClientFailed(err))),
  );

  /**
   * Si se carga la informacion del cliente se invoca la verificacion del usuario
   */
  @Effect()
  getClientSuccess$ = this.actions
    .ofType(clientActions.GET_CLIENT_SUCCESS)
    .pipe(
      map(() => new authActions.VerifyAuth()),
  );

  @Effect()
  init$ = defer(() => Observable.of(new clientActions.GetClient()));

  constructor(
    private actions: Actions,
    private clientProvider: ClientData,
  ) { }
}



// WEBPACK FOOTER //
// ./src/ngrx/effects/client.effects.ts